import { render, staticRenderFns } from "./user-role-management.vue?vue&type=template&id=7e89aade&scoped=true"
import script from "./user-role-management.vue?vue&type=script&lang=js"
export * from "./user-role-management.vue?vue&type=script&lang=js"
import style0 from "./user-role-management.vue?vue&type=style&index=0&id=7e89aade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e89aade",
  null
  
)

export default component.exports